/**
 * Branded type for AtlasId strings.
 * Format: `macro|email@example.com`
 */
declare const AtlasIdBrand: unique symbol;
export type AtlasId = string & { readonly [AtlasIdBrand]: never };

/**
 * Type guard to check if a string is a valid AtlasId.
 */
export function isAtlasId(str: string): str is AtlasId {
  return str.startsWith('macro|') && str.slice(6).includes('@');
}

/**
 * Attempts to parse a string as a AtlasId.
 * Returns the AtlasId if valid, undefined otherwise.
 */
export function tryAtlasId(str: string): AtlasId | undefined {
  return isAtlasId(str) ? str : undefined;
}

/**
 * Extracts the email from a AtlasId.
 */
export function atlasIdToEmail(id: AtlasId): string {
  return id.slice(6);
}

/**
 * Creates a AtlasId from an email address.
 * Returns undefined if the email is invalid.
 */
export function emailToAtlasId(email: string): AtlasId | undefined {
  if (!email.includes('@')) {
    return undefined;
  }
  return `macro|${email}` as AtlasId;
}
